'use strict';

/// 缓存管理
var cache = {};

exports.cache = function (k, v) {
  if (v === undefined) {
    return cache[k];
  }
  cache[k] = v;
  return v;
};

exports.keys = {
  PROJECT_VERSION: 'PROJECT_VERSION',
  PAGE_VERSION: 'PAGE_VERSION',
  PLATFORM: 'PLATFORM'
};



// WEBPACK FOOTER //
// ./src/helper/cacheHelper.js